import React, { useState, useEffect } from 'react'
import Title from './Title';
import { Table, TableHead, TableRow, TableCell, TableBody, Button, Grid, makeStyles, CircularProgress, Typography, Select, MenuItem } from '@material-ui/core';
import {history, MyMess} from '../../App'
import { useSelector } from 'react-redux';
import { GlobalSnackBarUtil } from '../../component/GlobalSnackBar';
import { GetLicenses, openDirectLogin } from '../../server/WebServiceUrl';
import Axios from 'axios';
import TextField from '@material-ui/core/TextField';
import CachedIcon from '@material-ui/icons/Cached';
import AddIcon from '@material-ui/icons/Add';
import {OrangeButton, GreenButton, BlueButton} from '../../component/colorButton';
import {CircularProgressWithLabel} from '../../component/CircularProgressWithLabel'
import LicenseAdminDialog from './LicenseAdmin/LicenseAdminDialog';
 

// function createKopaProData(id, code, desc,plan, expiryDate){
//   return {id, code, desc,plan,expiryDate};
// }

// const license = [
//   createKopaProData('0', 'flossygarden', 'Flossy Garden','et', '2021-12-31'),
//   createKopaProData('1', 'wffc', 'Wing Fung','pm', '2021-12-31'),
//   createKopaProData('2', 'jckopapro', 'Joseph Debug','su', '2021-11-27')
// ]

const useStyles = makeStyles((theme) => ({
  btn: {
    '&:first-of-type': {
      marginRight: '3px',
    },
    marginBottom: '3px',
  },
  spinner: {
    margin: 10
  },
  tableAppBar: {
    '& > *':{
      marginLeft: theme.spacing(1)
    }
  },
  paper: {
    width: '80%',
    maxHeight: 435,
  },
  shopNameCol:{
    maxWidth: 60,
    wordBreak: 'break-all'
  },
  shopDescCol:{
    maxWidth: 300,
    wordBreak: 'break-all'
  }
}));

const getPlan = (planCode) => {
  switch(planCode){
  case 'su':
    return MyMess.kopaproLicense.plan.su
  case 'bu':
    return MyMess.kopaproLicense.plan.bu
  case 'pm':
    return MyMess.kopaproLicense.plan.pm
  case 'et':
     return MyMess.kopaproLicense.plan.et    
  default:
    return 'N/A'
  }
  
}
const parseDate = (date) => {
  var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}


export default function KopaProLicense() {  
  // const debug = (e) => {
  //   GlobalSnackBarUtil.open({
  //     message: 'hahaha',
  //     severity:'error',
  //     onCloseHandler: () => {
  //       GlobalSnackBarUtil.close();
  //     }
  //   })
  // }
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const [license,setLicense] = useState([]);
  const [isFetching, setFetching] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [filteredLicense, setFilteredLicense] = useState(license);
  const [selectedLicense, setSelectedLicense] = useState({
    code:''
  })


  const [licenseStatus, setLicenseStatus] = useState('active');
  const [openAdminDialog, setOpenAdminDialog] = useState(false);


  useEffect(()=> {

    if(user.authorization){
      runRefresh()
    }

    return ;
  },[licenseStatus])

  useEffect(() => {
    setFetching(true);
    const timer = setTimeout(() => {
      const filter = license.filter(l => {
        return l.code.toLowerCase().includes(keyword.toLowerCase()) || l.desc.toLowerCase().includes(keyword.toLowerCase());
      });
      setFetching(false);
      setFilteredLicense(filter);
    }, 1000);

    return () => clearTimeout(timer);
  }, [keyword, license]);

  

  const extendButtonHandler = (e,licenseId) => {    
    history.push('/main/kopapro/extend/' + licenseId);
  }

  const changeButtonHandler = (e,licenseId) => {
    history.push('/main/kopapro/edit/' + licenseId);
  }

  const readButtonHandler = (e,licenseId) => {
    history.push('/main/kopapro/read/' + licenseId);
  }

  const adminButtonHandler = (e,licenseId) => {
    setOpenAdminDialog(true);
    setSelectedLicense({
      ...selectedLicense,
      code: licenseId
    })
  }

  const refreshHandler = (e) => {
    if(user.authorization){
      runRefresh()
    }
  }

  const runRefresh =async () => {
    setFetching(true);
    let res = await Axios.get(`${GetLicenses}?status=${licenseStatus}`);
    if(res && res.status === 200 && res.data && res.data.pass){
      let myLicenses = [];
      myLicenses = res.data.shopLicenses;
      setLicense(myLicenses);
    }else{
      GlobalSnackBarUtil.open({
        message:MyMess.refreshFail,
        severity:'error'
      })
    }
    setFetching(false);
  }

  const isPaidBefore = (license) => {
    if(!license.licensePayments || typeof license.licensePayments !== 'object' || license.licensePayments.length === 0 ) {
      return false
    }

    const isFound = license.licensePayments.find( e => {
      let amount = parseFloat(e.amt);
      return amount > 0 && e.status === 'paid'
    })
    return typeof isFound === 'object'
  }

  const openSiteHanler = (kppcode) => {
    // setTrialSiteState({
    //   loading:true
    // })
    const startNnlVisit = async (code) => {        
      openDirectLogin(code);  
      // setTrialSiteState({
      //   loading:false
      // })
    }

    startNnlVisit(kppcode);
    
  }

  const openRebranchHandler = (kppcode) => {
    // setTrialSiteState({
    //   loading:true
    // })
    const startNnlVisit = async (code) => {        
      openDirectLogin(code);  
      // setTrialSiteState({
      //   loading:false
      // })
    }

    startNnlVisit(kppcode);
    
  }

  
  const handleAdminClose = () => {
    setOpenAdminDialog(false);    
  };

  const renderTableBody =() => {

    if (isFetching) {
      return (
        <TableBody>
          <TableRow>
            <TableCell align='center' colSpan={7}>
                <CircularProgress className={classes.spinner} size={36} thickness={4} />
              </TableCell>
          </TableRow>
        </TableBody>
      )
    }

    let paidLicense = (filteredLicense || []).filter( license => {
      return license.branchComplete || isPaidBefore(license)
    })

    if(paidLicense && paidLicense.length > 0) {
      return (
        <TableBody>
          {paidLicense.map((lic) => (
            <TableRow key={lic.code}>
              {//(user.type === 'sse' || user.type === 'admin') && <TableCell>{lic.client}</TableCell> 
              }
              <TableCell className={classes.shopNameCol}>{lic.code}</TableCell>
              <TableCell className={classes.shopDescCol}>{lic.desc}</TableCell>
              <TableCell>{getPlan(lic.plan)}</TableCell>
              <TableCell>{MyMess.kopaproLicense[lic.status]}</TableCell>
              
              <TableCell>
                { 
                  lic.m18Status !== 'pending' && MyMess.kopaproLicense[lic.m18Status]
                }
                {
                  lic.m18Status == 'pending' && <CircularProgressWithLabel  value={lic.m18Progress} text={MyMess.kopaproLicense[lic.m18Status]} />
                }
              </TableCell>
              <TableCell>{parseDate(lic.expDate)}</TableCell>
              <TableCell>                 
                 <BlueButton onClick={ e => {readButtonHandler(e,lic.code)}} variant="contained" color="primary">{MyMess.kopaproLicense.details}</BlueButton>
                 {lic.status !== 'pending' && user.type !== 'admin' && 
                 <BlueButton style={{marginLeft: 10}} onClick={ e => {openSiteHanler(lic.code)}} variant="contained" color="primary">{MyMess.kopaproLicense.visit}</BlueButton>}
                 {
                 //lic.status !== 'pending' && (user.role === 'sse' || user.role === 'admin') && <OrangeButton onClick={ e => {openRebranchHandler(lic.code)}} variant="contained" color="primary">{MyMess.kopaproLicense.rebranch}</OrangeButton>
                 }
              </TableCell>
              <TableCell>
                {/*force to hide change button */}
                {false && <GreenButton onClick={ e => {changeButtonHandler(e,lic.code)}} variant="contained" color="primary">{MyMess.change}</GreenButton>}

                {(user.type === 'sse' || user.type === 'admin') && <GreenButton onClick={ e => {adminButtonHandler(e,lic.code)}} variant="contained" color="primary">{MyMess.kopaproLicense.sysAdmin}</GreenButton>}
                {lic.status !== 'pending' && <OrangeButton onClick={ e => {extendButtonHandler(e,lic.code)}} variant="contained" color="primary">{isPaidBefore(lic)?MyMess.extend: MyMess.kopaproLicense.payAndSubscribe}</OrangeButton>}                
                
              </TableCell>

              
            </TableRow>
          ))}
        </TableBody>
      )

    } else if(!isFetching){     
      return (
        <TableBody>
          <TableRow>
            <TableCell align='center' colSpan={7}>
              <Typography variant="subtitle1">{MyMess.general.noRecord}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      )
    }
  }

  return (
    <React.Fragment>
      <Grid container={true} justify="space-between">
        <Grid item xs={6}>
          <Title>{MyMess.kopaproLicenses}</Title>
        </Grid>  
        <Grid container justify="flex-end" className={classes.tableAppBar} >
          <TextField size="small" label={MyMess.general.search} variant="outlined" onChange={e => setKeyword(e.target.value)} />
          {
             user.type === 'admin' &&
             <Select
                labelId="license-status-label"
                id="license-status-select"
                value={licenseStatus}
                onChange={ e => setLicenseStatus(e.target.value)}
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'active'}>Active</MenuItem>
                <MenuItem value={'pending'}>Pending</MenuItem>
                <MenuItem value={'expired'}>Expired</MenuItem>
            </Select>
              
            
          }
          <Button variant="contained" onClick={refreshHandler} color="primary" startIcon={<CachedIcon />} >
              {MyMess.refresh}
          </Button>
          <Button variant="contained" onClick={e => {history.push('/main/kopapro/create')}}  color="primary" startIcon={<AddIcon />} >
              {MyMess.addNewShop}
          </Button>
        </Grid>
      </Grid>      
      

      <Table size="small">
        <TableHead>
          <TableRow>
            {//(user.type === 'sse' || user.type === 'admin')&& <TableCell>{MyMess.kopaproLicense.client}</TableCell>
            }
            <TableCell>{MyMess.kopapro}</TableCell>
            <TableCell>{MyMess.kopaproLicense.desc}</TableCell>
            <TableCell>{MyMess.kopaproLicense.plan.plan}</TableCell>
            <TableCell>{MyMess.kopaproLicense.status}</TableCell>
            <TableCell>{MyMess.kopaproLicense.serverStatus}</TableCell>
            <TableCell>{MyMess.kopaproLicense.expiryDate}</TableCell>
            <TableCell align="right"></TableCell>
            <TableCell align="right"></TableCell>            
          </TableRow>
        </TableHead>
        
        {renderTableBody()}

        <LicenseAdminDialog       
          id="ringtone-menu"
          classes={{
            paper: classes.paper,
          }}
          keepMounted
          open={openAdminDialog} 
          onClose={handleAdminClose}                
          licenseCode={selectedLicense.code || ''}
        />      
      </Table>      
    </React.Fragment>
  )
}
